import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { FindHttpError } from '../error/find-http-error';

@Injectable()
export class AttendingResponsabilityService {
  private END_POINT = '/attending-responsability';
  _httpService: HttpService;


  constructor(private httpService: HttpService) {
    this._httpService = httpService;
  }

  getResponsabilities() {
    return this._httpService.get(`${this.END_POINT}/`, Array, FindHttpError);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/attendiing-responsability.service.ts